export default __webpack_public_path__ + "62d1b16c7450363cfdf525b5686ec3b5.png";